<template>
  <div class="app">
    <navG :isBack='false' :isNum="0"></navG>
    <banner :list="list" :Dtype="'heng'"></banner>
    <list :list="listL" :listT="listT" @qie="qie"></list>
    <gift></gift>
    <welfare></welfare>
    <gyl></gyl>
    <system></system>
    <bottom></bottom>
    <hotline></hotline>
  </div>
</template>

<script>
import navG from '../../components/navG'
import Banner from '../../components/Banner'

import list from './components/list'
import gift from './components/gift'
import welfare from './components/welfare'
import gyl from './components/gyl'
import system from './components/system'

import hotline from '../../components/hotline'
import bottom from '../../components/bottom'
export default {
  name: 'index',
  components: {
    navG,
    Banner,
    list,
    gift,
    welfare,
    gyl,
    system,
    hotline,
    bottom
  },
  data () {
    return {
      list: [{
        banner_img: require('../../assets/img/index/banner.png')
      }, {
        banner_img: require('../../assets/img/index/banner1.png')
      }, {
        banner_img: require('../../assets/img/index/banner2.png')
      }, {
        banner_img: require('../../assets/img/index/banner3.png')
      }],
      listL: [{
        name: '场景化礼品定制',
        img: 'icon-dingzhi',
        desc: '<p>精准触达用户需求</p><p>提升采购选品效能</p>'
      }, {
        name: '企业福利',
        img: 'icon-fuliguanli',
        desc: '<p>数字化企业福利</p><p>给员工做深层次的关怀</p>'
      }, {
        name: '全品类供应链资源输出',
        img: 'icon-pinleiguihua',
        desc: '<p>去中间, 惠两端, 厂货直递</p>'
      }, {
        name: '多元化终端系统赋能',
        img: 'icon-zuanshi',
        desc: '<p>多款系统供您体验</p>'
      }],
      listT: 0
    }
  },
  mounted () {
    
  },
  methods: {
    qie (i) {
      this.listT = i
    }
  }
}
</script>
<style lang="stylus">
.title
  display flex
  justify-content space-between
  .titleT
    font-size px(32)
    color #333333
    font-weight 500
  .titleA
    font-size px(24)
    color #666666
    a
      color #666666
    .iconfont
      font-size px(18)
      margin-left px(8)
</style>
<style lang="stylus" scoped>
.app
  padding-bottom px(110)
.navUL
  width 100%
  display flex
  li
    width 25%
    text-align center
  li.action
    color #D22016
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue